<template>
    <v-text-field
        v-model="modelValue"
        ref="input"
        dense
        counter
        maxlength="5"
        :append-icon="appendIcon"
        @click:append="save"
        :loading="saving"
        @focus="editing = true"
        @blur="editing = false"
        :error="error"
        @keydown.enter="save"
    >
    </v-text-field>
</template>

<script>
    import {SnackBarAction, SnackBarTypes} from "../../store/snackbar/types";
    import {mapActions} from "vuex";
    import axios from "axios";

    export default {
        props: {
            value: {
                type: [String, Number],
            },
            id: {
                type: [String, Number],
                required: true,
            },
        },
        created() {
            this.modelValue = this.value;
        },
        data: () => ({
            editing: false,
            modelValue: null,
            saving: false,
            error: false,
        }),
        computed: {
            appendIcon() {
                let icon = '';

                if(this.editing) {
                    icon = 'mdi-content-save';
                } else if(this.error) {
                    icon = 'mdi-warning';
                }

                return icon;
            },
        },
        methods: {
            ...mapActions({
                setSnackbar: `snackbar/${SnackBarAction.SET}`,
            }),
            save() {
                this.saving = true;
                this.editing = false;
                this.$refs.input.blur();

                this.$emit('change', this.modelValue);

                axios.post(`/inquiry/${this.id}/in-charge`, {
                    inCharge: this.modelValue,
                })
                    .then(resp => {
                        return resp.data;
                    })
                    .then(data => {
                        this.saving = false;
                        this.error = false;

                        this.setSnackbar({
                            data: data.message,
                            type: SnackBarTypes.SUCCESS,
                        });
                    })
                    .catch(err => {
                        this.saving = false;
                        this.error = true;

                        this.setSnackbar({
                            data: err.message,
                            type: SnackBarTypes.ERROR,
                        });
                    });
            },
        }
    }
</script>
